export default __webpack_public_path__ + "img/ami-logo-mark.c2ea541d.png";